import dayjs from "dayjs";

export const getConstantValue = (value: any, constants?: any[] | undefined) => {
  const findedConstant = constants?.find((constant) => {
    return constant.value === value;
  });

  return findedConstant ? findedConstant.label : "";
};

export const getRemoteFileUrl = (uid: string) =>
  process.env.REACT_APP_UPLOAD_URL + uid;

export const createToken = (length: number = 12) => {
  let templateString =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._@";

  let password = "";
  for (let i = 0; i <= length; i++)
    password += templateString.charAt(
      Math.floor(Math.random() * templateString.length + 1)
    );

  return password;
};

export const getOptionsFromEntities = (
  entityArray: any,
  labelName = "name",
  valueName = "@id"
) => {
  return entityArray.map((entity: any) => {
    return {
      id: entity["id"],
      label: entity[labelName],
      value: entity[valueName],
    };
  });
};

export const getFormattedDate = (value: string, format?: string) => {
  return dayjs(value).format(format ?? "DD.MM.YYYY");
};
